<template>
  <v-dialog v-model="visible" @keydown.esc="handleCancelButtonClick" max-width="600">
    <v-card>
      <v-card-title class="headline">Add samples</v-card-title>
      <v-card-text class="text--primary">
        <v-form v-model="formValid">
          <v-text-field label="Prefix" v-model="output.prefix" :rules="prefixRules"></v-text-field>
          <v-select label="Samples count" v-model="output.count" :items="indexList"></v-select>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary darken-1"
               text
               :disabled="!formValid"
               @click="handleOkButtonClick">
          Ok
        </v-btn>

        <v-btn color="gray darken-1"
               text
               @click="handleCancelButtonClick">
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import _ from 'lodash'
import {SamplePrefixRegex} from '../../dictionaries/common-rules'

export default {
  name: "SampleAddDialog",
  props: {
    prefix: {
      type: String,
      default: 'T'
    },
    count: {
      type: Number,
      default: 1
    }
  },
  data() {
    let indexList = _.range(1, 21)

    return {
      formValid: false,
      visible: false,
      output: {
        prefix: this.prefix,
        count: this.count,
      },
      indexList: indexList,
      prefixRules: [
        v => !!v || 'Enter prefix',
        function (v) {
          return SamplePrefixRegex.test(v) || 'Wrong symbols'
        },
        function (v) {
          return (v && v.length <= 50) || 'The length of the prefix should be no more than 50 characters'
        }
      ]

    }
  },
  methods: {
    show() {
      this.visible = true
    },
    hide() {
      this.visible = false
    },
    handleOkButtonClick() {
      this.$emit('add', _.cloneDeep(this.output))
      this.hide()
      this.reset()
    },
    handleCancelButtonClick() {
      this.hide()
      this.reset()
    },
    reset() {
      this.output = {
        prefix: 'T',
        count: 1
      }
    }
  }
}
</script>

<style scoped>

</style>